import styled from 'styled-components';
import {
  applyAspectRatioBoxInsideStyles,
  applyAspectRatioBoxStyles,
} from '@tcp/core/src/utils/utils.web';

export const StyledModuleWrapper = styled.div`
  ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'DESKTOP')}
  }
`;

export const StyledModule = styled.div`
  ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'DESKTOP')}
  }
`;
